import { NavigateToFunction } from "../../core/routing/routingHooks";
import React from "react";

export type NavigatePreviewContextValue = {
  navigateTo?: NavigateToFunction;
  previewMode: string | null;
  setPreviewOverrideSlug: (slug: string | null) => void;
  setPreviewMode: (mode: string) => void;
};

const NavigatePreviewContext =
  React.createContext<NavigatePreviewContextValue | null>(null);

export default NavigatePreviewContext;
